<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="6" sm="8" md="9">
                    <h1 class="headline font-weight-light mb-3">
                        SETTING
                    </h1>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" sm="4" md="3" class="text-right">
                    <v-btn
                        color="primary"
                        dark
                        small
                        rounded
                        @click="change_add_group()"
                    >
                        <v-icon class="mr-1">mdi-plus</v-icon>
                        Add group
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card>
                        <!-- <v-card-title>xx</v-card-title> -->
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">#</th>

                                        <th class="text-center">Group Name</th>
                                        <th class="text-center">Manage</th>
                                        <th class="text-center">Del.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in data_main"
                                        :key="index"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td>{{ row.group_name }}</td>
                                        <td class="text-center">
                                            <v-btn
                                                color="amber"
                                                x-small
                                                fab
                                                @click="
                                                    get_group_deatil(
                                                        row.group_id
                                                    )
                                                "
                                            >
                                                <v-icon>mdi-widgets</v-icon>
                                            </v-btn>
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                x-small
                                                fab
                                                color="red lighten-1"
                                                @click="del_group(row.group_id)"
                                            >
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- Modal Add group -->
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="400px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Group</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form_add_group.group_name"
                                        label="Group name"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close_add_group()"
                        >
                            Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            :disabled="form_add_group.group_name == ''"
                            @click="add_group()"
                        >
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- Modal group detail -->
        <v-row justify="center">
            <v-dialog
                v-model="dialogGroup"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card tile>
                    <v-toolbar flat dark color="primary">
                        <v-btn icon dark @click="close_group_deatil()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-title></v-toolbar-title> -->
                    </v-toolbar>
                    <v-card-text>
                        <v-form method="post" id="nativeForm" v-model="valid">
                            <div>
                                <v-row>
                                    <v-col cols="12">
                                        <h3>Group</h3>
                                    </v-col>
                                    <v-col cols="10" sm="5" md="6">
                                        <v-text-field
                                            v-model="form.group_name"
                                            label="Group name"
                                            required
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-switch
                                            v-model="form.status"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                <v-row v-for="(r, i) in form.parts" :key="i">
                                    <v-col cols="10" sm="5" md="3">
                                        <v-select
                                            :items="data_project"
                                            v-model="r.project_id"
                                            item-text="project_name"
                                            item-value="project_id"
                                            menu-props="auto"
                                            label="Select Project"
                                            hide-details
                                            dense
                                            outlined
                                            @change="get_category(i)"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="10" sm="5" md="3">
                                        <v-select
                                            :items="data_category[i]"
                                            v-model="r.category_id"
                                            item-text="category_name"
                                            item-value="category_id"
                                            menu-props="auto"
                                            label="Select Category"
                                            hide-details
                                            dense
                                            outlined
                                            @change="get_part(i)"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="10" sm="5" md="3">
                                        <v-select
                                            :items="data_part[i]"
                                            v-model="r.part_id"
                                            item-text="part_description"
                                            item-value="part_id"
                                            menu-props="auto"
                                            label="Select Part"
                                            hide-details
                                            dense
                                            outlined
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-btn
                                            v-if="i + 1 === num"
                                            fab
                                            x-small
                                            color="blue accent-1"
                                            @click="plus(i)"
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            fab
                                            x-small
                                            color="red lighten-1"
                                            @click="del(i)"
                                        >
                                            <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-4">
                                    <v-col cols="12" sm="4" md="3">
                                        <v-btn
                                            color="success"
                                            @click="save_group_deatil()"
                                            block
                                        >
                                            <v-icon class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "alternative-part/view-group-all", this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.data_main = response.data
                })
        },
        change_add_group() {
            this.dialog = true
        },
        close_add_group() {
            this.form_add_group.group_name = ""
            this.dialog = false
        },
        async add_group() {
            await axios
                .post(
                    url + "alternative-part/create-group",
                    this.form_add_group,
                    this.tk
                )
                .then((response) => {
                    this.close_add_group()
                    this.mutatesnackbar()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                    this.get_data()
                })
        },
        del_group(groupId) {
            this.$swal({
                title: "Are you sure you delete group ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(
                            url + "alternative-part/delete-group/" + groupId,
                            {},
                            this.tk
                        )
                        .then((response) => {
                            this.mutatesnackbar()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            this.chk_data = true
                        })
                }
            })
        },
        async get_group_deatil(groupId) {
            this.group_id = groupId
            this.mutateIsLoading()
            await axios
                .get(
                    url + "alternative-part/view-group-detail/" + this.group_id,
                    this.tk
                )
                .then((response) => {
                    this.num = response.data[0].parts.length
                    this.form = { ...response.data[0] }
                    this.get_project()
                    if (response.data[0].parts[0].part_id != null) {
                        response.data[0].parts.map((r, i) => {
                            this.get_category(i)
                            this.get_part(i)
                        })
                    }
                    this.mutateIsLoading()

                    this.dialogGroup = true
                })
        },
        async get_project() {
            await axios
                .get(url + "alternative-part/get-project", this.tk)
                .then((response) => {
                    this.data_project = response.data
                })
        },
        async get_category(i) {
            await axios
                .get(
                    url +
                        "alternative-part/get-category/" +
                        this.form.parts[i].project_id,
                    this.tk
                )
                .then((response) => {
                    this.$set(this.data_category, i, response.data)
                })
        },
        async get_part(i) {
            await axios
                .get(
                    url +
                        "alternative-part/get-part/" +
                        this.form.parts[i].project_id +
                        "/" +
                        this.form.parts[i].category_id,
                    this.tk
                )
                .then((response) => {
                    this.$set(this.data_part, i, response.data)
                })
        },
        plus() {
            this.num = this.num + 1
            this.form.parts.push({
                project_id: null,
                category_id: null,
                part_id: null,
            })
        },
        del(i) {
            this.form.parts.splice(i, 1)
            this.num -= 1
        },
        close_group_deatil() {
            this.num = 1
            this.dialogGroup = false
        },
        async save_group_deatil() {
            this.mutateIsLoading()
            await axios
                .post(
                    url + "alternative-part/update-group/" + this.group_id,
                    this.form,
                    this.tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    this.close_group_deatil()
                    this.mutatesnackbar()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                    this.get_data()
                })
        },
    },
    data() {
        return {
            tk: null,
            data_main: null,
            dialog: false,
            form_add_group: {
                group_name: "",
            },
            dialogGroup: false,
            valid: false,
            form: {
                part: [
                    {
                        project_id: null,
                        category_id: null,
                        part_id: null,
                    },
                ],
            },
            data_project: [],
            data_category: {},
            data_part: {},
            num: 1,
            group_id: null,
            text: "Success, Your work has been saved",
        }
    },
}
</script>
